import { Controller } from "@hotwired/stimulus"
import { getReadableDistributionValues } from "../../assets/javascripts/source/shared/data/checkboxOptions";

// Connects to data-controller="custom-request"
export default class extends Controller {

  static targets = ["form", "otherCheckbox", "notes"];
  static values = {
    songVersionId: Number
  }


  connect() {
    this.boundOpenCustomRequestForm = this.openCustomRequestForm.bind(this)
    this.boundSetDefaultPlaceholder = this.setDefaultPlaceholder.bind(this)
    this.boundSetHoverPlaceholder = this.setHoverPlaceholder.bind(this)
    if (this.hasFormTarget) {
      // find all inputs of type "text", "tel", "email"
      this.inputs = Array.from(this.formTarget.getElementsByTagName("input")).filter(input => ["text", "tel", "email"].includes(input.type));
      this.inputs.forEach(input => {
        input.setAttribute("placeholder", input.getAttribute("default-placeholder"));
        input.addEventListener("mouseover", this.boundSetHoverPlaceholder);
        input.addEventListener("mouseout", this.boundSetDefaultPlaceholder);
      });
    }
    document.addEventListener("custom_request:form", this.boundOpenCustomRequestForm);
  }
  
  disconnect() {
    document.removeEventListener("custom_request:form", this.boundOpenCustomRequestForm);
    this.inputs?.forEach(input => {
      input.removeEventListener("mouseover", this.boundSetHoverPlaceholder);
      input.removeEventListener("mouseout", this.boundSetDefaultPlaceholder);
    });
  }

  parseDistributions(checkBoxElements) {
    const selectedDistributions = [];
    checkBoxElements.forEach(checkbox => {
      if (checkbox.checked) {
        selectedDistributions.push(checkbox.value);
      }
    });
    return selectedDistributions;
  }

  handleOtherCheckboxChange(event) {
    const isChecked = event.target.checked;
    const notesField = this.notesTarget;
    if (isChecked) {
      notesField.setAttribute("required", "");
    } else {
      notesField.removeAttribute("required");
    }
  }

  submitHandler(e){
    e.preventDefault()
    const formData = new FormData(e.target);
    const body = {
      song_version_id: e.params.id,
      name: formData.get("sender_name"),
      email: formData.get("sender_email"),
      phone: formData.get("sender_phone"),
      company: formData.get("sender_company"),
      company_location: formData.get("sender_location"),
      end_client: formData.get("end_client"),
      project_title: formData.get("project_title"),
      distribution: getReadableDistributionValues(Array.from(e.target.querySelectorAll("input[type='checkbox']:checked")).map(cb => cb.value)),
      term: formData.get("term"),
      territory: formData.get("territory"),
      use: formData.get("use"),
      music_budget: formData.get("budget"),
      exclusivity: formData.get("exclusivity"),
      notes: formData.get("notes")
    }

    fetch(`/licensing/custom-request`, {
      method: "POST", 
      headers:{
        "Content-Type": "application/json",
      },
      body: JSON.stringify({custom_request: body})
    }).then(res => res.text())
    .then(async(html) => {
      await Turbo.renderStreamMessage(html)
    })
  }

  openCustomRequestForm(event) {
    const { songVersionId } = event.detail;
    const modal = document.querySelector("[data-controller='modal']");
    if (modal) {
      const modalController = this.application.getControllerForElementAndIdentifier(modal, "modal");
      const openEvent = new CustomEvent("modal:open", { detail: { size: "large" } });
      modalController?.open(openEvent);
    }
    Turbo.visit(`/licensing/custom_request_form/${songVersionId}`, { frame: "active-modal-content" })
  }

  setDefaultPlaceholder(input) {
    input.target.setAttribute("placeholder", input.target.getAttribute("default-placeholder"));
  }

  setHoverPlaceholder(input){
    input.target.setAttribute("placeholder", input.target.getAttribute("hover-placeholder"));
  }
}